import { ATS_PUBLIC_CAREER_SITE } from './constants';

export const es = {
  [ATS_PUBLIC_CAREER_SITE]: {
    VACANCY: 'Vacante',
    DEPARTMENT: 'Departamento',
    POSITION: 'Posición',
    CLOSED_DATE: 'Fecha de cierre',
    PUBLISHED_DATE: 'Publicado hace {{days}}',
    SEARCH_BY_NAME: 'Buscar por nombre',
    DAY: 'día',
    MONTH: 'mes',
    YEAR: 'año',
    DAYS: 'días',
    MONTHS: 'meses',
    YEARS: 'años',
    CLOSED_DATE_CARD: 'Fecha de cierre: {{date}}',
    FILTER_BY: 'Filtrar por',
    SEARCH_BY_DEPARTMENT: 'Buscar por departamento',
    NO_DEPARTMENTS_FOUND: 'No se encontraron departamentos',
    TRY_ANOTHER_SEARCH: 'Intenta otra búsqueda',
    VACANCY_EXAMPLE: 'Vacante de ejemplo',
    OPEN_DATE_EXAMPLE: 'Publicado hace 3 días',
    DEPARTMENT_EXAMPLE: 'departamento',
    CAREER_SITE_STATUS_TITLE_NOT_FOUND: 'Portal de empleo no encontrado',
    CAREER_SITE_STATUS_DESCRIPTION_NOT_FOUND:
      'Intenta nuevamente en unos minutos',
    ERROR_PAGE_TITLE_CAREER_SITE: 'Error al cargar el portal de empleo',
    ERROR_PAGE_DESCRIPTION_CAREER_SITE:
      'Ha ocurrido un error inesperado. Por favor, intenta de nuevo.',
    RETRY: 'Reintentar',
  },
};
